import {TableFilterKey} from "../model/filters/TableFiltersDefinitions";

export const UpdateFiltersPages = (updateFilterPage: (value: any) => void) => {
    updateFilterPage({key: TableFilterKey.NOMENCLATURE_GUIDE_FILTER, value: 0})
    updateFilterPage({key: TableFilterKey.USER_GUIDE_FILTER, value: 0})
    updateFilterPage({key: TableFilterKey.PRODUCTION_ORDER_EXECUTION_JOURNAL_FILTER, value: 0})
    updateFilterPage({key: TableFilterKey.INDIVIDUALS_GUIDE_FILTER, value: 0})
    updateFilterPage({key: TableFilterKey.ADMINISTRATIVE_ROLE_GUIDE_FILTER, value: 0})
    updateFilterPage({key: TableFilterKey.TECHNOLOGICAL_PROCESS_CHART_GUIDE_FILTER, value: 0})
    updateFilterPage({key: TableFilterKey.PRODUCTION_STAGE_GUIDE_FILTER, value: 0})
    updateFilterPage({key: TableFilterKey.TECHNOLOGICAL_OPERATION_GUIDE_FILTER, value: 0})
    updateFilterPage({key: TableFilterKey.ADMINISTRATIVE_AND_FUNCTIONAL_ZONE_GUIDE_FILTER, value: 0})
    updateFilterPage({key: TableFilterKey.PRODUCTION_ORDER_JOURNAL_FILTER, value: 0})
    updateFilterPage({key: TableFilterKey.PRODUCTION_ORDER_ARCHIVE_FILTER, value: 0})
    updateFilterPage({key: TableFilterKey.PRODUCTION_ORDER_ANALYSIS_BY_TIME_FILTER, value: 0})
    updateFilterPage({key: TableFilterKey.MEASUREMENT_UNIT_GUIDE_FILTER, value: 0})
    updateFilterPage({key: TableFilterKey.MEASUREMENT_OKEI_GUIDE_FILTER, value: 0})
}